import { CsError } from "../../../../../logic/CsError"
import { useIsPinPage } from "../../../../../logic/useIsPinPage"
import { GenericPinErrorDialog } from "./GenericPinErrorDialog"
import { PinSessionEndedErrorDialog } from "./PinSessionEndedErrorDialog"

export function PinErrorDialogFallbacks({error} : { error: Error | CsError }) {
  const isPinPage = useIsPinPage() 
  if (error.cause === 'no_pin_token') {
    return (
      <PinSessionEndedErrorDialog/>
    )
  }
  if (isPinPage) {
    return (
      <GenericPinErrorDialog error={ error } />
    )
  }
  //Not a pin error so don't render anything.
  return null
}
